import { useLanguage } from "../context/LanguageContext";
import { IMAGES } from "../constants/site";
import Reveal from "../components/Reveal";
import { ShieldCheck, Radar, Lock, Sparkles } from "lucide-react";
import { useSeo } from "../hooks/useSeo";

const ICONS = [ShieldCheck, Radar, Lock, Sparkles];

export default function About() {
  const { t } = useLanguage();
  useSeo(
    "About Us | MIRAL GROUP",
    "MIRAL GROUP — protocol-trained chauffeurs, 100% electric Tesla fleet and absolute discretion. Our story, mission and executive standards in Antwerp."
  );

  return (
    <main className="pt-[72px]">
      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
          <Reveal>
            <p className="eyebrow">{t.about.eyebrow}</p>
            <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight">
              {t.about.title}
            </h1>
            <p className="mt-6 max-w-[60ch] text-lg text-slate-300 leading-relaxed">{t.about.lead}</p>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="mt-14 relative rounded-2xl overflow-hidden border border-white/10">
              <img src={IMAGES.brussels} alt="Antwerp by night" className="h-[320px] lg:h-[460px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070709] via-transparent to-transparent" />
            </div>
          </Reveal>

          <div className="mt-16 grid gap-10 lg:grid-cols-2">
            <Reveal>
              <p className="text-slate-300 leading-relaxed">{t.about.p1}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-slate-300 leading-relaxed">{t.about.p2}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="border-y border-white/10 bg-[#090a0e]">
        <div className="mx-auto max-w-7xl px-5 lg:px-10 py-20 lg:py-28 grid gap-12 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <div className="relative rounded-2xl overflow-hidden border border-gold/20">
              <img src={IMAGES.chauffeur} alt="Chauffeur" className="h-[300px] lg:h-[420px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070709]/85 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 rounded-xl border border-white/10 bg-black/50 backdrop-blur px-5 py-4">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-gold-soft">{t.about.missionEyebrow}</p>
                <p className="mt-1.5 font-display text-lg font-bold text-white">{t.about.missionTitle}</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-lg text-slate-300 leading-relaxed">{t.about.missionText}</p>
            <p className="mt-8 eyebrow">{t.about.standardsEyebrow}</p>
            <div className="mt-6 grid sm:grid-cols-2 gap-4">
              {t.about.standards.map((s, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={s.t}
                    data-testid={`about-standard-${i}`}
                    className="group rounded-xl border border-white/10 bg-white/[0.03] p-5 transition-colors duration-500 hover:border-gold/40"
                  >
                    <Icon size={20} className="text-gold" />
                    <h3 className="mt-3 font-display text-base font-semibold text-white">{s.t}</h3>
                    <p className="mt-1.5 text-sm text-slate-400">{s.d}</p>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
